// extracted by mini-css-extract-plugin
module.exports = {"main":"StagingAreaPage_main_wlKDR","titleContainer":"StagingAreaPage_titleContainer_Kzpqb","spinAround":"StagingAreaPage_spinAround_1ag41"};